<span c-select options="sorts" selected-option="sortFilter"></span>
<section class="details log">
    <article ng-repeat="activity in activityLog|orderBy: sortFilter.value + 'Timestamp'" c-activity-log activity="activity" class="record"></article>
</section>